"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#95BF47",
        fillRule: "nonzero",
        d: "M15.095 4c.402 0 .863.212 1.246.713h.115c1.324 0 2.072 1.138 2.493 2.371.422-.135.69-.212.71-.212.096-.038.384-.077.518.058.063.056.315.304.59.577l.236.236.115.115.21.21.089.09.179.18s1.822.134 1.918.134c.096 0 .192.077.21.193l1.312 8.918.115.779 1.182 8.038-7.384 1.6-13.616-2.564.814-6.327.09-.702c.44-3.397.88-6.796.918-7.024.077-.636.096-.655.767-.867a92.02 92.02 0 012.148-.675C10.53 7.875 12.007 4 15.095 4zm-.096.829c-2.206 0-3.452 2.91-3.97 4.704a68.023 68.023 0 001.88-.579c.44-2.352 1.514-3.527 2.492-3.99a.667.667 0 00-.402-.135zm.92.867c-.748.328-1.61 1.196-2.07 2.95.805-.25 1.63-.501 2.377-.733v-.135c0-.925-.115-1.6-.307-2.082zm.844-.135c.154.482.269 1.1.269 1.87v.25c.422-.134.805-.25 1.15-.365-.287-.906-.728-1.677-1.419-1.755z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#5E8E3E",
        d: "M23.583 8.626c-.093 0-1.87-.134-1.87-.134S20.479 7.23 20.33 7.096A.348.348 0 0020.143 7l-1.01 21 7.2-1.587S23.808 8.95 23.79 8.836c-.02-.134-.131-.191-.206-.21z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M16.133 12.76l-.894 2.678s-.8-.418-1.75-.418c-1.427 0-1.484.893-1.484 1.12 0 1.216 3.196 1.69 3.196 4.557 0 2.26-1.427 3.703-3.368 3.703-2.32 0-3.5-1.443-3.5-1.443l.628-2.05s1.217 1.044 2.245 1.044c.666 0 .95-.532.95-.912 0-1.595-2.624-1.67-2.624-4.29 0-2.203 1.579-4.349 4.794-4.349 1.198 0 1.807.36 1.807.36z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Shopify.js.map